import { createReducer } from '@reduxjs/toolkit';
import InitialState from './../reducers/initial-state';
import * as UIActions from '../actions/ui';
import { jumpContext } from '../actions/contexts.action';
import { cancelEula, saveEula } from '../actions/eula';

const reducer = createReducer(InitialState.eula, (builder) => {
  builder.addCase(UIActions.logout.type, () => ({ ...InitialState.eula }));
  builder.addCase(jumpContext.pending.type, () => ({ ...InitialState.eula }));

  builder.addCase(saveEula, (state, action) => ({
    ...state,
    eula: action.payload
  }));

  builder.addCase(cancelEula, (state, action) => ({
    ...state,
    isCancelled: action.payload
  }));
});

export default reducer;
